import React, { useEffect, useState } from 'react';
import { HeadingText } from '@paypalcorp/pp-react';
import { parseMessages } from '../../utilityHelper';

const getRemainingTime = function (millis) {
  const language = document.getElementsByTagName('html')[0].getAttribute('lang');
  const messages = parseMessages('givingfund');
  const remainingTimeOptions = { minute: '2-digit', second: '2-digit' };

  const remainingTime = new Date(0);
  remainingTime.setMilliseconds(millis + (remainingTime.getTimezoneOffset() * 60 * 1000));
  return messages.profile.sessionModal.head.replace('{time}', remainingTime.toLocaleTimeString(
    language,
    remainingTimeOptions
  ));
};

export const CountdownTimer = (props) => {
  const { expireTime = 0, lastActivity = 0 } = props;

  const calculateRemainingTime = () => {
    return expireTime - (Date.now() - lastActivity);
  };

  const [timeLeft, setTimeLeft] = useState(calculateRemainingTime());

  useEffect(() => {
    if (timeLeft > 0) {
      if (props.pause) return;
      const intervalId = setInterval(() => {
        setTimeLeft(calculateRemainingTime());
      }, 1000);
      return () => clearInterval(intervalId);
    }
    setTimeLeft(0);
    props.onTimeout(true);
  }, [timeLeft, props.pause]);

  return (
    <HeadingText level={2} style={props.styles}>
      {getRemainingTime(timeLeft)}
    </HeadingText>
  );
};

export default CountdownTimer;